<div class="banner-image container" *ngIf="hasUrl" fxLayoutAlign="center center">
  <img [ngStyle]="{'max-width': width + 'px', 'max-height': maxHeight ? maxHeight + 'px' : null}" [src]="getLogoUrl()" [alt]="'BANNER_IMAGE.ALT' | translate"/>
</div>
